export default {
    homePage: "https://stapto.com",
    firebaseHosts: ["stapto-home.web.app", "stapto-home.firebaseapp.com"],
    facebookPage: "https://www.facebook.com/staptoco/",
    playStorePage: "https://play.google.com/store/apps/dev?id=4713343487399056042",
    instagramPage: "https://www.instagram.com/stapto_com",
    buyMeACoffeePage: "https://www.buymeacoffee.com/arunnambissan",
    reCaptchaKey: "6Le98boUAAAAADurVBDBqDijpW2HMOQI-wzsMMsd"
}